import "babel-polyfill";
import ReactDOM from "react-dom";
import { App } from "./app";
import { store } from "./store";

const container = document.getElementById("app-container");


ReactDOM.render(App({ store }), container);



// WEBPACK FOOTER //
// ./src/js/index.js